export const companyLoader = {
  memberCompany: 'memberCompany',
  detailCompany: 'detailCompany',
  companyCategoryGroup: 'companyCategoryGroup',
  companyClassification: 'companyClassification',
  companyType: 'companyType',
  companyLibray: 'companyLibray',
  companyCustomOrganization: 'companyCustomOrganization',
  companyDirectorate: 'companyDirectorate',
  companyFTEClassification: 'companyFTEClassification',
  companyLevelDescription: 'companyLevelDescription',
  companyRegion: 'companyRegion',
  companyWorkerType: 'companyWorkerType',
  competency_move: 'competency_move',
  list_skill_group: 'list_skill_group',
  list_sub_skill_group: 'list_sub_skill_group',
  companyCompetencyDetail: 'companyCompetencyDetail',
  list_multiple_sub_skill_group: 'list_multiple_sub_skill_group',
};
export const initialStateCompany = {
  memberCompany: true,
  detailCompany: true,
  companyCategoryGroup: true,
  companyClassification: true,
  companyType: true,
  companyLibray: true,
  companyCustomOrganization: true,
  companyDirectorate: true,
  companyFTEClassification: true,
  companyLevelDescription: true,
  companyRegion: true,
  companyWorkerType: true,
  competency_move: true,
  list_skill_group: true,
  list_sub_skill_group: true,
  companyCompetencyDetail: true,
  list_multiple_sub_skill_group: true,
};
